module.exports = __webpack_public_path__ + "assessoria-aos-gestores.png?3b19a174e45b170f7a4d170c888d79a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assessoria-aos-gestores.png
// module id = 230
// module chunks = 0